import { ServiceType } from '@rover/constants/src/translations/service.constants';
import {
  type SearchParamsPetCounts,
  SearchParamsPetType,
} from '@rover/constants/src/translations/sitterProfilePage.constants';
import TextWithSingleInlineLink from '@rover/kibble/official-patterns/TextWithSingleInlineLink';
import {
  AlertContentEnum,
  getAlertContent,
} from '@rover/react-lib/src/pages/search/SearchPage/components/SearchSectionHeader/builders/constants';
import { getBookingFeeLearnMoreUrl } from '@rover/react-lib/src/utils/bookingFeeUtils';
import type { CountryConfigurationUrls } from '@rover/rsdk/src/apiClient/latest/model/countryConfigurationUrls';
import { EnhancedPersonSitterProfileService } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfileService';

import { usePrimaryPetType } from '../../utils/utils';

type Props = {
  bookingFeePercentage: string;
  petCounts: SearchParamsPetCounts;
  onBookingFeeClick: () => void;
  serviceType?: string;
  countryConfigUrls?: CountryConfigurationUrls;
  petType?: SearchParamsPetType;
  services?: EnhancedPersonSitterProfileService[];
};

const BannerContent = ({
  bookingFeePercentage,
  petCounts,
  onBookingFeeClick,
  serviceType,
  countryConfigUrls,
  petType,
  services,
}: Props): JSX.Element | null => {
  const displayPetType = usePrimaryPetType(petCounts, petType, services);

  const paragraphText = getAlertContent(AlertContentEnum.PRICE_TRANSPARENCY_FULL_SITTER_PROFILE, {
    serviceType: serviceType as ServiceType,
    petType: displayPetType,
    bookingFeePercentage,
  });

  return (
    <TextWithSingleInlineLink
      onClick={onBookingFeeClick}
      paragraphText={paragraphText}
      href={getBookingFeeLearnMoreUrl(countryConfigUrls)}
      target="_blank"
      size="200"
      linkFontWeight="semibold"
    />
  );
};

export default BannerContent;
